export default function Bg() {
  return (
    <div className="landing-hero-bg">
      <div className="landing-hero-orb landing-hero-orb--one" />
      <div className="landing-hero-orb landing-hero-orb--two" />
      <div className="landing-hero-orb landing-hero-orb--three" />
    </div>
  );
}
